export default function getCardDetailsFactory(ajax, getSession) {
  return async function getCardDetail(id, document_type, token) {
    return ajax({ resource: `themes/${document_type}s/${id}`, method: 'get' });
  };
}



// WEBPACK FOOTER //
// ./src/services/getCardDetail.js